import type {Shipment} from '@myparcel-frontend/order-service';
import type {PaperSize, PrintLabelPosition, ValueOf} from '@myparcel-frontend/types';
import {ref} from 'vue';
import {NAME} from '@/components/ui/Modal';
import {useModal} from '@/composables/useModal';

const selectedShipments = ref<Shipment[]>([]);
const isROW = ref(false);
const confirmedDownloadSettings = ref<
  | {
      labelFormat: ValueOf<typeof PaperSize>;
      positions: ValueOf<typeof PrintLabelPosition>[];
    }
  | undefined
>();

export function usePrintLabelModal() {
  const {openModal, closeModal, isModalOpen} = useModal(NAME.LABEL_PRINT);

  const openPrintModal = (shipments: Shipment | Shipment[], isRestOfWorld: boolean): void => {
    selectedShipments.value = Array.isArray(shipments) ? shipments : [shipments];
    isROW.value = isRestOfWorld;
    openModal();
  };

  const confirmPrintModal = ({
    labelFormat,
    positions,
  }: {
    labelFormat: ValueOf<typeof PaperSize>;
    positions: ValueOf<typeof PrintLabelPosition>[];
  }): void => {
    // Store the confirmed settings for downloadShipmentLabels to use
    confirmedDownloadSettings.value = {labelFormat, positions};
    closePrintModal();
  };

  const closePrintModal = (): void => {
    closeModal();
    selectedShipments.value = [];
    isROW.value = false;
  };

  const cancelPrintModal = (): void => {
    confirmedDownloadSettings.value = undefined;
    closePrintModal();
  };

  return {
    selectedShipments,
    isRestOfWorld: isROW,
    openPrintModal,
    confirmPrintModal,
    cancelPrintModal,
    isPrintModalOpen: isModalOpen,
    confirmedDownloadSettings,
  };
}
